<template>
  <div class="wrapper">
    <div class="tabs">
      <div
        v-for="tab in tabs"
        :key="tab"
        :class="{
          tab: true,
          activeTab: activeTab === tab,
        }"
        @click="activeTab = tab"
      >
        {{ tab }}
      </div>
    </div>
    <div class="tabs-content">
      <div
        v-for="tab in tabs"
        :key="tab"
        :class="{
          'tab-content': true,
          activeTab: activeTab === tab,
        }"
      >
        <div class="translation-row" v-for="(key, value) in translations[tab]" :key="value">
          <template v-if="value !== '____plural'">
            <pre class="translation-key">{{ value }}</pre>
            <div class="translation-value" v-html="t(value)"></div>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import { useI18n } from '@/composables';
import en from '@/i18n/lang/en.json';
import es from '@/i18n/lang/es.json';
import ru from '@/i18n/lang/ru.json';
import zh from '@/i18n/lang/zh.json';

const { t } = useI18n();

const activeTab = ref('en');

const translations = {
  en,
  es,
  ru,
  zh,
};

const tabs = ['en', 'es', 'ru', 'zh'];
</script>

<style lang="scss" scoped>
.wrapper{
  padding:5px;
}
.tabs{
  display: flex;
  padding:5px 0;
}

.tab{
  border:1px solid gray;
  min-width: 100px;
  cursor:pointer;
  padding:5px;
  &.activeTab{
    background:gray;
    color:white;
  }
}

.tab-content{
  display:none;
  &.activeTab{
    display:block;
  }
}

.translation-key{
  font-weight: bold;
  word-break: break-all;
  white-space: pre-wrap;
}

.translation-value{
  word-break: break-all;
}

.translation-row{
  margin-bottom:6px;
  border:1px solid #ccc;
  padding:5px;
}
</style>
